<template>
  <div class="reward-shop-container">
    <div class="reward-shop-header">
      <h2>🎁 Premi</h2>
      <p class="subtitle">
        Sblocca temi, badge, strumenti e funzionalità esclusive
      </p>
    </div>
    <RewardPass :userCredits="utente?.crediti_totali_acquistati || 0" />
    <div class="coin-balance">
      Coin acquistati:
      <span class="coin">{{ studio?.crediti_totali_acquistati || 0 }}</span>
    </div>

    <div class="reward-grid">
      <div
        v-for="tier in tiers"
        :key="tier.soglia"
        class="reward-card"
        :class="{ unlocked: utente?.crediti_totali_acquistati >= tier.soglia }"
      >
        <div class="reward-card-content">
          <h3>{{ tier.feature }}</h3>
          <p class="description">{{ tier.description }}</p>
          <div class="reward-footer">
            <span class="cost">{{ tier.soglia }} coin</span>
            <span
              v-if="utente?.crediti_totali_acquistati >= tier.soglia"
              class="badge-unlocked"
              >✅ Sbloccato</span
            >
            <span v-else class="locked">🔒 Bloccato</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_BASE_URL } from "../config";
import RewardPass from "../components/RewardPass.vue";

export default {
  name: "RewardShop",
  components: {
    RewardPass,
  },
  data() {
    return {
      studio: null,
      utente: null,
      tiers: [
        {
          soglia: 0,
          feature: "Modalità chiaro/scuro",
          description: "Personalizza l’aspetto dell’app.",
        },
        {
          soglia: 250,
          feature: "Sfondi personalizzati",
          description: "Scegli sfondi per la tua dashboard.",
        },
        {
          soglia: 500,
          feature: "Icone animate",
          description: "Icone più dinamiche e moderne.",
        },
        {
          soglia: 750,
          feature: "Badge profilo",
          description: "Aggiungi distintivi al tuo profilo.",
        },
        {
          soglia: 1000,
          feature: "Editor tema avanzato",
          description: "Modifica colori e stile dell’interfaccia.",
        },
        {
          soglia: 2000,
          feature: "Storico illimitato",
          description: "Accedi a tutte le operazioni passate.",
        },
        {
          soglia: 3000,
          feature: "Modalità Pro",
          description: "Funzionalità esclusive per power user.",
        },
        {
          soglia: 5000,
          feature: "Tema Galaxy 🚀",
          description: "Tema esclusivo con animazioni cosmiche.",
        },
      ],
    };
  },
  mounted() {
    this.fetchUtente();
    this.fetchStudio();
  },
  methods: {
    async fetchUtente() {
      try {
        const res = await axios.get(`${API_BASE_URL}/utente/info_personale`);
        this.utente = res.data;
      } catch (err) {
        console.error("Errore fetch utente:", err);
      }
    },
    async fetchStudio() {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/admin/get_studio_by_admin`
        );
        this.studio = res.data.studio;
      } catch (err) {
        console.error("Errore fetch studio:", err);
      }
    },
  },
};
</script>

<style scoped>
.reward-shop-container {
  max-width: 1000px;
  margin: 2rem auto;
  padding: 1rem;
  font-family: "Segoe UI", sans-serif;
  display: none;
}

.reward-shop-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.subtitle {
  color: #666;
  font-size: 0.95rem;
}

.coin-balance {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

.coin {
  font-weight: bold;
  color: #f39c12;
}

.reward-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 1.5rem;
}

.reward-card {
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 1rem;
  background-color: #fff;
  transition: all 0.3s;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.reward-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.reward-card.unlocked {
  border-color: #4caf50;
  background-color: #e8f5e9;
}

.reward-card-content h3 {
  margin: 0;
  font-size: 1.2rem;
}

.description {
  font-size: 0.9rem;
  margin: 0.5rem 0;
  color: #555;
}

.reward-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

.cost {
  font-weight: bold;
  color: #f39c12;
}

.locked {
  color: #aaa;
  font-size: 0.9rem;
}

.badge-unlocked {
  color: #4caf50;
  font-weight: bold;
}
</style>
